// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Linkedin: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <path
                fill="currentColor"
                d="M18.5714293,0 L1.42410755,0 C0.638392993,0 0,0.647321429 0,1.44196374 L0,18.5580363 C0,19.3526786 0.638392993,20 1.42410755,20 L18.5714293,20 C19.3571438,20 20,19.3526786 20,18.5580363 L20,1.44196374 C20,0.647321429 19.3571438,0 18.5714293,0 Z M6.04464327,17.1428571 L3.08035782,17.1428571 L3.08035782,7.59821415 L6.04910782,7.59821415 L6.04910782,17.1428571 L6.04464327,17.1428571 Z M4.56250054,6.29464286 C3.61160755,6.29464286 2.84375054,5.52232197 2.84375054,4.57589286 C2.84375054,3.62946374 3.61160823,2.85714286 4.56250123,2.85714286 C5.50892966,2.85714286 6.28125123,3.62946374 6.28125123,4.57589286 C6.28125123,5.52678517 5.51339422,6.29464286 4.56250123,6.29464286 L4.56250054,6.29464286 Z M17.1562501,17.1428571 L14.1919647,17.1428571 L14.1919647,12.5 C14.1919647,11.3928577 14.1696433,9.96875014 12.6517861,9.96875014 C11.107143,9.96875014 10.8705364,11.1741066 10.8705364,12.4196434 L10.8705364,17.1428571 L7.90625095,17.1428571 L7.90625095,7.59821415 L10.7500008,7.59821415 L10.7500008,8.90178544 L10.7901791,8.90178544 C11.1875003,8.15178531 12.1562501,7.36160687 13.5982152,7.36160687 C16.5982144,7.36160687 17.1562501,9.33928558 17.1562501,11.9107137 L17.1562501,17.1428571 Z"
                transform="translate(-.001)"
            />
        </svg>
    );
};

export default React.memo(Linkedin);
